import { useEffect, useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useMonthlyReportUIContext } from "../MonthlyReportUIContext";

const prepareFilter = (queryParams, values) => {
  let { term, date, dateEnd, sectionId, studentId, studentNumber, bookCount, pageNumberCount } = values;
  studentNumber = studentNumber === "" ? null : studentNumber;
  bookCount = bookCount === "" ? null : bookCount;
  pageNumberCount = pageNumberCount === "" ? null : pageNumberCount;
  const newQueryParams = { ...queryParams };
  const filter = { date, dateEnd, sectionId, studentId, studentNumber, bookCount, pageNumberCount };
  newQueryParams.filter = filter;
  newQueryParams.term = term;
  return newQueryParams;
};

export function MonthlyReportFilter() {
  // Monthly Report UI Context
  const monthlyReportUIContext = useMonthlyReportUIContext();
  const monthlyReportUIProps = useMemo(() => {
    return {
      term: monthlyReportUIContext.term,
      date: monthlyReportUIContext.date,
      dateEnd: monthlyReportUIContext.dateEnd,
      sectionId: monthlyReportUIContext.sectionId,
      studentId: monthlyReportUIContext.studentId,
      queryParams: monthlyReportUIContext.queryParams,
      setQueryParams: monthlyReportUIContext.setQueryParams
    };
  }, [monthlyReportUIContext]);

  useEffect(() => {
    applyFilter({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [monthlyReportUIProps.term, monthlyReportUIProps.date, monthlyReportUIProps.dateEnd, monthlyReportUIProps.sectionId, monthlyReportUIProps.studentId]);
  
  
  const applyFilter = (values) => {
    values.term = monthlyReportUIProps.term;
    values.date = monthlyReportUIProps.date;
    values.dateEnd = monthlyReportUIProps.dateEnd;
    values.sectionId = monthlyReportUIProps.sectionId;
    values.studentId = monthlyReportUIProps.studentId;
    const newQueryParams = prepareFilter(monthlyReportUIProps.queryParams, values);
    if (!isEqual(newQueryParams, monthlyReportUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      monthlyReportUIProps.setQueryParams(newQueryParams);
    }
  };
  
  return (
    <Formik
      initialValues={{
        studentNumber: "",
        bookCount: "",
        pageNumberCount: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="studentNumber"
                min={1}
                placeholder="Öğrenci Numarası"
                onBlur={handleBlur}
                value={values.studentNumber}
                onChange={(e) => {
                  setFieldValue("studentNumber", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Öğrenci Numarası</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="bookCount"
                min={1}
                placeholder="Kitap Sayısı"
                onBlur={handleBlur}
                value={values.bookCount}
                onChange={(e) => {
                  setFieldValue("bookCount", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kitap Sayısı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="pageNumberCount"
                min={1}
                placeholder="Sayfa Sayısı"
                onBlur={handleBlur}
                value={values.pageNumberCount}
                onChange={(e) => {
                  setFieldValue("pageNumberCount", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sayfa Sayısı</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}